import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
    // {
    //   path: '/',
    //   name: 'Home',
    //   component: Home
    // },
    {
        // 首页
        path: '/',
        name: 'HomePage',
        component: () =>
            import ('../views/homePage/HomePage.vue')

    },
    {
        //产融供应链
        path: '/CrSupplyChain',
        name: 'CrSupplyChain',
        component: () =>
            import ('../views/crSupplyChain/cr-supply-chain.vue')
    },
    {
        // 产融科技
        path: '/CrTechnology',
        name: 'CrTechnology',
        component: () =>
            import ('../views/crTechnology/cr-technology.vue')
    },
    {
        // 产融大数据
        path: '/CrBigData',
        name: 'CrBigData',
        component: () =>
            import ('../views/crBigData/cr-big-data.vue')
    },
    {
        // 数字产业聚集区
        path: '/SzcyGatheringArea',
        name: 'SzcyGatheringArea',
        component: () =>
            import ('../views/szcyGatheringArea/szcy-gathering-area.vue')
    },
    {
        // 阳光购销
        path: '/YgPurchaseAndSale',
        name: 'YgPurchaseAndSale',
        component: () =>
            import ('../views/ygPurchaseAndSale/yg-purchase-and-sale.vue')
    },
    {
        // 关于
        path: '/About',
        name: 'About',
        component: () =>
            import ('../views/about/about.vue')
    },
    {
        // 入驻流程
        path: '/ApplicationProcess',
        name: 'ApplicationProcess',
        component: () =>
            import ('../views/applicationProcess/application-process.vue')
    },
    {
        // 再生资源
        path: '/newResources',
        name: 'newResources',
        component: () =>
            import ('../views/newResources/new-Resources.vue')
    },
    {
        // 建材砂石
        path: '/buildingMaterialsSand',
        name: 'buildingMaterialsSand',
        component: () =>
            import ('../views/buildingMaterialsSand/building-materials-sand.vue')
    },


]

const router = new VueRouter({
    routes,
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    }
})

export default router